import React from 'react';
import { Panel, PanelResizeHandle } from 'react-resizable-panels';

import CardDialog from '~/components/CardDialog';

interface SidePanelCardDialogProps {
  children: React.ReactNode;
  resizeHandleId?: string;
  panelId?: string;
  minSize?: number;
  maxSize?: number;
  headerStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
}

export const SidePanelCardDialog: React.FC<SidePanelCardDialogProps> = ({
  children,
  resizeHandleId = 'resize-handle',
  panelId = 'side-panel',
  minSize = 35,
  maxSize = 80,
  headerStyle = { padding: '0' },
  contentStyle = { padding: '0' },
  containerStyle = {},
}) => {
  return (
    <>
      <PanelResizeHandle id={resizeHandleId} className="mx-12 w-2 rounded-lg bg-slate-500" />
      <Panel id={panelId} style={{ overflow: 'auto' }} minSize={minSize} maxSize={maxSize}>
        <CardDialog headerStyle={headerStyle} contentStyle={contentStyle} containerStyle={containerStyle} noCardTitle>
          {children}
        </CardDialog>
      </Panel>
    </>
  );
};

export default SidePanelCardDialog;
